<!--
  --
  --
  --
  -->
<template>
  <div class="d-flex align-center h-12">
    <span>支払方法の登録がありません。</span>
  </div>
</template>

<script>
export default {
  name: 'CNoPaymentSheet'
}
</script>
